import StatisticsUI from "./components/StatisticsUI";

const Statistics = () =>  <StatisticsUI />

export default Statistics;